import React from 'react'
import styled from '@emotion/styled-base'
import {css} from '@emotion/core'

export const plusIconSizes = {
  xlg: {
    height: 24,
    width: 40
  },
  lg: {
    height: 18,
    width: 30
  },
  md: {
    height: 16,
    width: 28
  },
  sm: {
    height: 14,
    width: 24
  },
  xs: {
    height: 12,
    width: 22
  }
}

export const plusIconVariants = {
  tag: 'M19.313 6.4a2443.21 2443.21 0 0 0-2.157 8.253c-.039.17-.088.317-.088.431l.004.07.006.032.078-.052.061-.047.15-.124.18-.166.23-.223.707.55-.367.359-.246.252-.211.206c-.096.09-.179.162-.249.216-.202.156-.409.243-.623.243-.283 0-.527-.138-.71-.382a1.232 1.232 0 0 1-.252-.757c0-.174.038-.42.112-.75l1.683-7.38Zm-5.008.125c.513 0 .942.188 1.258.554.303.35.45.808.45 1.36 0 .651-.16 1.303-.475 1.951a6.547 6.547 0 0 1-1.27 1.765 6.497 6.497 0 0 1-1.774 1.275c-.657.318-1.315.479-1.97.479-.106 0-.221-.008-.346-.024l-.194-.03-.065-.011-.63 2.556H7.8l1.071-4.356.117-.503c.11-.504.203-1.024.277-1.56a14.332 14.332 0 0 0 .145-2.216l-.004-.11-.012-.238 1.598-.64-.001.827-.018.412-.023.342-.043.507.083-.11.238-.294c.491-.583.998-1.046 1.523-1.39.55-.36 1.067-.546 1.554-.546ZM25.29 9.562l-1.093 4.16c-.098.404-.147.729-.147.97a.74.74 0 0 0 .063.34l-.005-.011.018-.008a.614.614 0 0 0 .021-.014l.024-.016.123-.097.075-.067.177-.17.1-.102.106-.115.246-.272.699.622-.33.369-.263.308-.23.259-.196.206c-.059.06-.112.11-.16.153-.236.208-.477.323-.728.323-.332 0-.611-.17-.814-.471-.06-.09-.11-.186-.15-.288l-.023-.07-.18.17c-.446.39-.901.611-1.37.652l-.159.007c-.421 0-.778-.131-1.046-.395-.27-.264-.403-.614-.403-1.027 0-.275.038-.601.112-.98l.693-3.663 1.794-.77-1.11 4.501-.044.192c-.05.233-.073.43-.073.592 0 .135.034.225.102.29.07.07.161.103.294.103.391 0 .87-.382 1.402-1.199l.657-3.709 1.818-.773Zm4.872.288c.426 0 .794.088 1.1.27.345.205.538.499.538.856 0 .45-.254.781-.704.94l-.39.136-.064-.403a.724.724 0 0 0-.298-.503c-.177-.129-.414-.196-.72-.196a1.14 1.14 0 0 0-.675.199c-.165.115-.228.217-.228.32 0 .136.142.319.481.535l.883.578c.664.462 1.018.965 1.018 1.516 0 .42-.147.813-.434 1.17-.277.344-.648.615-1.11.814a3.6 3.6 0 0 1-1.438.294c-.822 0-1.524-.31-2.086-.918l-.225-.244 1.244-1.18.297.52c.298.48.728.712 1.332.712.336 0 .612-.085.84-.253.208-.153.296-.305.296-.472a.392.392 0 0 0-.114-.29 1.319 1.319 0 0 0-.106-.096l-.164-.128-.222-.16c-.042-.029-.086-.06-.132-.09l-.487-.325-.317-.222a3.833 3.833 0 0 1-.537-.455 1.229 1.229 0 0 1-.34-.854c0-.39.142-.752.416-1.074a2.74 2.74 0 0 1 1.024-.728c.418-.18.86-.269 1.322-.269ZM13.988 7.61c-.273 0-.627.155-1.053.484-.457.353-.91.837-1.357 1.455a6.93 6.93 0 0 0-.802 1.406c-.145.341-.335.897-.57 1.668.856.086 1.596-.08 2.221-.495.938-.624 1.504-1.522 1.716-2.122.21-.598.314-1.107.314-1.526 0-.321-.058-.556-.162-.707a.336.336 0 0 0-.307-.164Z',
  text: 'M13.59 5.403c.598 0 1.099.234 1.467.69.353.435.525 1.004.525 1.69 0 .81-.186 1.62-.554 2.428a8.15 8.15 0 0 1-1.483 2.194 7.612 7.612 0 0 1-2.069 1.586c-.767.395-1.534.595-2.298.595-.185 0-.395-.023-.63-.067l-.075-.014-.735 3.179H6l1.25-5.417.136-.625c.129-.627.236-1.274.323-1.94.115-.885.173-1.7.173-2.445 0-.17-.003-.318-.009-.447l-.013-.297 1.864-.795-.001 1.027-.02.513-.028.425-.05.63.097-.137.277-.365c.573-.725 1.165-1.301 1.777-1.728.642-.448 1.245-.68 1.813-.68Zm6.063-.736-2.774 10.958c-.045.2-.066.37-.066.504l.004.083.008.037.09-.061c.022-.016.046-.034.071-.055l.175-.146.21-.197.27-.264.824.65-.428.424-.287.298-.247.243a4.198 4.198 0 0 1-.29.255c-.236.186-.477.288-.727.288-.33 0-.614-.164-.83-.452a1.468 1.468 0 0 1-.292-.894c0-.206.044-.496.13-.885l2.185-9.923 1.974-.863Zm-6.434 2.085c-.318 0-.732.193-1.228.603-.533.438-1.061 1.04-1.584 1.81a8.782 8.782 0 0 0-.935 1.748 15.907 15.907 0 0 0-.681 2.22l-.024.1.178-.224.478.128c.193.044.388.066.587.066.416 0 .84-.133 1.278-.406.452-.282.86-.684 1.227-1.21.342-.49.638-1.108.885-1.854.245-.744.367-1.378.367-1.899 0-.399-.068-.69-.19-.879-.093-.145-.198-.203-.358-.203Zm11.91 7.769 1.276-4.915-2.121.913-.767 4.382c-.621.965-1.179 1.416-1.635 1.416-.155 0-.26-.04-.343-.12-.08-.079-.12-.184-.12-.344 0-.191.028-.425.085-.7l.052-.226 1.296-5.318-2.094.91-.808 4.327a6.199 6.199 0 0 0-.131 1.157c0 .488.156.902.47 1.214.313.312.73.467 1.22.467l.186-.008c.547-.048 1.079-.31 1.598-.772l.21-.2.028.083c.046.12.104.234.175.34.236.356.561.557.948.557.294 0 .575-.136.85-.382.056-.05.118-.11.188-.181l.227-.243.268-.306.307-.364.386-.436-.816-.734-.286.32-.125.137-.116.121-.206.2c-.031.03-.06.055-.089.08l-.142.113a.875.875 0 0 1-.053.036l-.021.01.006.013c-.046-.086-.073-.219-.073-.4 0-.287.056-.671.17-1.147Zm6.96-4.575c-.54 0-1.055.106-1.542.318-.492.214-.892.5-1.194.86-.32.38-.487.807-.487 1.269 0 .38.136.722.397 1.008.14.153.347.33.627.537l.37.263.567.383c.055.037.106.073.155.108l.259.188.192.152c.052.044.094.082.123.114a.465.465 0 0 1 .133.341c0 .198-.103.377-.345.558-.266.199-.588.299-.98.299-.705 0-1.207-.273-1.554-.84l-.347-.616-1.451 1.395.262.288c.655.719 1.475 1.084 2.434 1.084a4.16 4.16 0 0 0 1.678-.347c.538-.235.971-.555 1.294-.961.335-.422.507-.887.507-1.383 0-.651-.413-1.245-1.187-1.79l-1.03-.684c-.396-.255-.563-.471-.563-.632 0-.121.075-.242.267-.378.22-.156.479-.234.788-.234.356 0 .633.079.84.23a.857.857 0 0 1 .347.595l.075.476.454-.161c.525-.187.822-.578.822-1.11 0-.422-.225-.769-.628-1.011-.357-.215-.787-.32-1.283-.32Z'
}

export const DEFAULT_PLUS_ICON_SIZE = 'xlg'
export const DEFAULT_PLUS_ICON_VARIANT = 'tag'

type VariantSizeProp =
  | {variant?: 'tag'; size?: typeof DEFAULT_PLUS_ICON_SIZE}
  | {variant?: 'text'; size?: keyof typeof plusIconSizes}

interface CommonProps {
  className?: string
  translateY?: string
  translateX?: string
}

type Props = CommonProps & VariantSizeProp

const SvgElement = styled('svg')(
  ({translateY, translateX}: Pick<Props, 'translateY' | 'translateX'>) => css`
    transform: translateY(${translateY}) translateX(${translateX});
  `
)

export const PlusIconWrapper = styled('div')(
  ({theme}) => css`
    position: absolute;
    right: 0;
    left: 0;
    width: 22px;
    height: 14px;
    margin: auto;
    display: flex;
    bottom: -4px;

    rect {
      stroke: ${theme.colors.defaultBg};
      stroke-width: 2px;
    }
  `
)

export const PlusIcon = ({
  className,
  translateY = '25%',
  translateX = '0',
  size = DEFAULT_PLUS_ICON_SIZE,
  variant = DEFAULT_PLUS_ICON_VARIANT
}: Props) => (
  <SvgElement
    className={className}
    width={
      variant === 'tag'
        ? plusIconSizes[DEFAULT_PLUS_ICON_SIZE].width
        : plusIconSizes[size].width
    }
    viewBox="0 0 40 24"
    xmlns="http://www.w3.org/2000/svg"
    translateY={translateY}
    translateX={translateX}
    data-id="plus-icon"
  >
    <g fill="none">
      <rect fill="#675CE9" width={40} height={24} rx={5} />
      <path d={plusIconVariants[variant]} fill="#FFF" />
    </g>
  </SvgElement>
)
